module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00056.05315a52.jpg";